import http from "../../../services/httpService";
import { error, isEmpty } from "../../common/global";
import { catchError } from "../../../utils/errorUtil";
import { openDialog, dialogModel } from "../../common/dialog";

const props = {
    adminProductEditMarker:'.marker-manual-finder-product-edit',
    deleteProductButton: '#delete-product',
    backLink: '#back-link'
};

export function initAdminManualFinderEditProduct() {
    if ($(props.adminProductEditMarker).length) {
        bindDeleteProduct();
    }
}


function bindDeleteProduct(){
    $(props.deleteProductButton).click(function () {

        const productId = $(this).data('id');

        openDialog({
            ...dialogModel,
            title: 'Delete Manual Finder Product',
            content: 'Are you sure you want to delete this manual finder product?',
            confirmButtonText: 'Delete',
            onConfirm: () => deleteProduct(productId),
            theme: 'delete'
        });
    });
}

async function deleteProduct(productId) {


    catchError(async function () {
        //attempt POST save, then check response

        const data = { id: productId };

        const response = await deleteProductService(data);

        if (response.responseType === "SUCCESS") {

            //success; redirect to the page that the user visited to get to this page
            var redirectUrl = $(props.backLink).attr("href");

            window.location.replace(redirectUrl);

        }
        else {

            //request failed; display popup for responsemessage to alert the user as to why
            openDialog({
                ...dialogModel,
                title: 'Error Encountered During Request',
                content: response.responseMessage,
                displayConfirm: false,
                cancelButtonText: 'Close',
                theme: 'delete'
            });
        }
    });
}




//API CALLS
async function deleteProductService(data) {

    //no TRY CATCH as handled by parent
    const response = await http.post('/administration/manualfindermanagement/deleteproduct', data);

    return response.data;
}